export const VIEW_CLIENT_DASHBOARD = "view_client_dashboard";
export const VIEW_CLINICIAN_LIST = "view_clinician_list";
export const CREATE_PROPOSED_EVENT = "create_proposed_event";
export const VIEW_SCHEDULE_PAGE = "view_schedule_page";
export const VIEW_MATCHING_PAGE = "view_matching_page";
export const VIEW_MESSAGES_PAGE = "view_messages_page";
export const VIEW_CLINICIAN_DASHBOARD = "view_clinician_performance_data";
export const DELETE_DOCUMENT = "delete_document";
export const GRANT_DOCUMENT_GENERATION_OVERRIDE = "grant_document_generation_override";
